import { ParsedUrlQuery } from 'querystring';

export interface PersonMentionAttribution {
  mentionId: string;
  requestId?: string;
}

const PERSON_MENTION_CHANNEL = 'pm';

const firstNonEmptyString = (
  value: string | string[] | undefined
): string | undefined => {
  const raw = Array.isArray(value) ? value[0] : value;
  if (typeof raw !== 'string') return undefined;
  const trimmed = raw.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

/**
 * Extracts PersonMention attribution from a Next.js router query.
 *
 * Returns the attribution only when the URL was opened via a PersonMention
 * email link (`?c=pm&mid=<uuid>[&aid=<uuid>]`). Returns null otherwise.
 *
 * Used by:
 *   - usePersonMentionPageVisitTracking (to fire trackPersonMentionPageVisit)
 *   - SignUpV2 (to populate SignUpV2Input.source)
 */
export const getPersonMentionAttribution = (
  query: ParsedUrlQuery
): PersonMentionAttribution | null => {
  const channel = firstNonEmptyString(query.c);
  if (channel !== PERSON_MENTION_CHANNEL) return null;

  const mentionId = firstNonEmptyString(query.mid);
  if (!mentionId) return null;

  const requestId = firstNonEmptyString(query.aid);
  return requestId ? { mentionId, requestId } : { mentionId };
};
